export const GET_REPORT_CARDS_START = 'GET_REPORT_CARDS_START'
export const GET_REPORT_CARDS_SUCCESS = 'GET_REPORT_CARDS_SUCCESS'
export const GET_REPORT_CARDS_FAILED = 'GET_REPORT_CARDS_FAILED'
